import { useMemo } from 'react'
import { useBillingUser, type IBillingSubscriptionTier } from '@/features/subscription/billing/billing-user-context'
import type { ISubscriptionErrorType } from '@/features/subscription/billing/billing-blocker'

export type ISubscriptionTier = IBillingSubscriptionTier

export function useSubscriptionTier() {
    const billingUser = useBillingUser()

    return useMemo(() => {
        if (!billingUser?.billingState) {
            return { tier: undefined, isCreditsExhausted: false, isCreditsLow: false }
        }

        const { tier, isCreditsExhausted, isCreditsLow } = billingUser.billingState
        return { tier, isCreditsExhausted, isCreditsLow }
    }, [billingUser])
}

export function getUpsellCtaLabel(tier: ISubscriptionTier | undefined): string {
    switch (tier) {
        case 'free_test':
            return 'Start free trial'
        case 'trial':
            return 'Activate subscription'
        default:
            return 'Upgrade now'
    }
}

export function getUpgradeCodeForTier(tier: ISubscriptionTier | undefined): ISubscriptionErrorType {
    switch (tier) {
        case 'free_test':
            return 'USAGE_LIMIT_REACHED_IN_FREE_TEST'
        case 'trial':
            return 'USAGE_LIMIT_REACHED_IN_TRIAL'
        default:
            return 'USAGE_LIMIT_REACHED'
    }
}
